/**
 * Canvas constants for rulers and guides
 */

export const RULER_SIZE = 20;
export const TICK_SMALL = 5;
export const TICK_MEDIUM = 10;
export const TICK_LARGE = 50;
